import { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import exit from '~/assets/icons/exit.svg';
import heart from '~/assets/icons/heart.svg';
import takeAuction from '~/assets/icons/take_auction.svg';
import { Text } from '~/components/ui/Text';
import { Apps } from '~/shared';
import auctionIcon from '../../assets/icons/apps/auction.svg';
import {
	resetAuctionSlice,
	returnToLauncher,
	setAuctionActiveFilter,
	setAuctionActivePage,
	setItemAuctionPageVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppAuctionCategorySelect } from '../AppAuctionCategorySelect';
import { AppAuctionCreate } from '../AppAuctionCreate';
import { AppAuctionDoneScreen } from '../AppAuctionDoneScreen';
import { AppAuctionItemSelect } from '../AppAuctionItemSelect';
import { AppAuctionItemPage } from '../AppAuctionItemPage';
import { AppAuctionItemsPage } from '../AppAuctionItemsPage';
import {
	StyledAppTitleContainer,
	StyledContainer,
	StyledExitButton,
	StyledFavoriteButton,
	StyledFilterButton,
	StyledItemPageContainer,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledMenuContainer,
	StyledRightContainer,
	StyledWrapper,
} from '../DefaultAppLayout';
import { LoadingScreen } from '../LoadingScreen';
import { getAppLoadingInfo } from '../TabletApp';
import {
	AppAuctionFilter,
	AppAuctionPages,
	appAuctionFilterButtons,
} from './AppAuction.model';

const AppAuction = () => {
	const dispatch = useLayoutDispatch();
	const activeFilter = useLayoutSelector(
		(state) => state.auction.activeAuctionFilter,
	);
	const activePage = useLayoutSelector(
		(state) => state.auction.activeAuctionPage,
	);
	const itemPageVisible = useLayoutSelector(
		(state) => state.auction.itemAuctionPageVisible,
	);
	const categorySelectVisible = useLayoutSelector(
		(state) => state.auction.categorySelectVisible,
	);
	const itemSelectVisible = useLayoutSelector(
		(state) => state.auction.itemSelectVisible,
	);
	const createVisible = useLayoutSelector(
		(state) => state.auction.createVisible,
	);
	const doneVisible = useLayoutSelector((state) => state.auction.doneVisible);
	const loadingInfo = getAppLoadingInfo(Apps.Auction);
	const [loading, setLoading] = useState(true);

	useEffectOnce(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1000);

		return () => {
			dispatch(resetAuctionSlice());
		};
	});

	return (
		<StyledWrapper>
			<SwitchTransition>
				<CSSTransition
					timeout={300}
					key={loading ? 0 : 1}
					classNames={'loading'}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
				>
					{loading ? (
						<LoadingScreen
							icon={loadingInfo.loadingIcon}
							text={loadingInfo.loadingMessage}
							color={loadingInfo.color}
							name={loadingInfo.name}
						/>
					) : (
						<StyledContainer>
							<StyledLayoutContainer $compact={itemPageVisible}>
								<StyledLeftContainer>
									<StyledAppTitleContainer>
										<img src={auctionIcon} />
										<div>
											<Text className={'title'}>Аукцион</Text>
											<Text className={'text'}>Стань коллекционером</Text>
										</div>
									</StyledAppTitleContainer>
									<StyledMenuContainer style={{ marginTop: 25, flex: 1 }}>
										{Object.values(AppAuctionFilter).map((item) => (
											<StyledFilterButton
												$active={
													activeFilter === item &&
													activePage === AppAuctionPages.Main
												}
												key={item}
												onClick={() => {
													dispatch(setAuctionActiveFilter(item));
													dispatch(setItemAuctionPageVisible(false));
													dispatch(setAuctionActivePage(AppAuctionPages.Main));
												}}
												$color={'#FF1E00'}
											>
												<img src={appAuctionFilterButtons[item].icon} />
												<Text>{appAuctionFilterButtons[item].name}</Text>
											</StyledFilterButton>
										))}
									</StyledMenuContainer>
									<StyledMenuContainer>
										<StyledFavoriteButton
											$active={activePage === AppAuctionPages.Favorites}
											onClick={() =>
												dispatch(
													setAuctionActivePage(AppAuctionPages.Favorites),
												)
											}
										>
											<img src={heart} />
											<Text>Избранное</Text>
										</StyledFavoriteButton>
										<StyledFilterButton
											$active={activePage === AppAuctionPages.MyBids}
											onClick={() =>
												dispatch(setAuctionActivePage(AppAuctionPages.MyBids))
											}
											$color={'#FF1E00'}
										>
											<img src={takeAuction} />
											<Text>Мои ставки</Text>
										</StyledFilterButton>
										{/* <StyledAddButton
											onClick={() => dispatch(setCategorySelectVisible(true))}
										>
											<img src={plusRound} />
											<Text>Добавить товар</Text>
										</StyledAddButton> */}
									</StyledMenuContainer>
									<StyledMenuContainer style={{ marginTop: 40 }}>
										<StyledExitButton
											$compact={itemPageVisible}
											onClick={() => dispatch(returnToLauncher())}
										>
											<img src={exit} />
											<Text>Выйти из приложения</Text>
										</StyledExitButton>
									</StyledMenuContainer>
								</StyledLeftContainer>
								<StyledRightContainer>
									<AppAuctionItemsPage />
									{itemPageVisible && (
										<StyledItemPageContainer>
											<AppAuctionItemPage />
										</StyledItemPageContainer>
									)}
								</StyledRightContainer>
							</StyledLayoutContainer>
							{categorySelectVisible && <AppAuctionCategorySelect />}
							{itemSelectVisible && <AppAuctionItemSelect />}
							{createVisible && <AppAuctionCreate />}
							{doneVisible && <AppAuctionDoneScreen />}
						</StyledContainer>
					)}
				</CSSTransition>
			</SwitchTransition>
		</StyledWrapper>
	);
};

export { AppAuction };
